/* 
 * Export component file to be used on project
*/

import MenuSidebar from './MenuSidebar.js';
export default MenuSidebar;
